const initialState = {
    collection: [],
    invalidBarcode: false,
    loading: false,
    discrepancyReasons: [],
    isProductDuplicate: false,
    isScanSearch: true,
    isCopyRequested: false,
    duplicateProductInfo: {},
    userDetails: {
        firstName: '',
        lastName: '',
        email: '',
        primaryPhone: '',
        country: '',
    },
};

const SET_STOCK_DISCREPANCY_COLLECTION = 'SET_STOCK_DISCREPANCY_COLLECTION';
const SET_DISCREPANCY_REASONS = 'SET_DISCREPANCY_REASONS';
const SET_USER_DETAILS = 'SET_USER_DETAILS';
const SET_IS_SCAN_SEARCH = 'SET_IS_SCAN_SEARCH';
const SET_IS_PRODUCT_DUPLICATE = 'SET_IS_PRODUCT_DUPLICATE';
const DUPLICATE_PRODUCT_INFO = 'DUPLICATE_PRODUCT_INFO';
const SET_IS_COPY_REQUESTED = 'SET_IS_COPY_REQUESTED';
const RESET_STOCK_DISCREPANCY = 'RESET_STOCK_DISCREPANCY';

export const setReportDiscrepancyCollection = (data) => ({
    type: SET_STOCK_DISCREPANCY_COLLECTION,
    payload: data,
});
export const setDiscrepancyReasons = (data) => ({ type: SET_DISCREPANCY_REASONS, payload: data });
export const setUserDetails = (data) => ({ type: SET_USER_DETAILS, payload: data });
export const setIsProductDuplicate = (data) => ({ type: SET_IS_PRODUCT_DUPLICATE, payload: data });
export const setIsScanSearch = (data) => ({ type: SET_IS_SCAN_SEARCH, payload: data });
export const setDuplicateProductInfo = (data) => ({ type: DUPLICATE_PRODUCT_INFO, payload: data });
export const setIsCopyRequested = (data) => ({ type: SET_IS_COPY_REQUESTED, payload: data });
export const resetStockDiscrepancy = () => ({ type: RESET_STOCK_DISCREPANCY });

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_STOCK_DISCREPANCY_COLLECTION:
            return { ...state, collection: action.payload };
        case SET_DISCREPANCY_REASONS:
            return { ...state, discrepancyReasons: action.payload };
        case SET_USER_DETAILS:
            return { ...state, userDetails: action.payload };
        case SET_IS_SCAN_SEARCH:
            return { ...state, isScanSearch: action.payload };
        case SET_IS_PRODUCT_DUPLICATE:
            return { ...state, isProductDuplicate: action.payload };
        case DUPLICATE_PRODUCT_INFO:
            return { ...state, duplicateProductInfo: action.payload };
        case SET_IS_COPY_REQUESTED:
            return { ...state, isCopyRequested: action.payload };
        case RESET_STOCK_DISCREPANCY:
            return { ...initialState };
        default:
            return state;
    }
};
